const initialState = {
    clienteSelecionado: null,
    diagnosticoSelecionado: null,
    formDirty: false,
}

const state = () => ({ ...initialState })

const mutations = {
    SELECT_CLIENTE(state, cliente) {
        state.clienteSelecionado = cliente
        state.formDirty = false
    },
    SELECT_DIAGNOSTICO(state, diagnostico) {
        state.diagnosticoSelecionado = diagnostico
        state.formDirty = false
    },
    SET_FORM_DIRTY(state, dirty) {
        state.formDirty = !!dirty
    },
    RESET(state) {
        Object.assign(state, { ...initialState })
    },
}

const getters = {
    clienteSelecionado: state => state.clienteSelecionado,
    diagnosticoSelecionado: state => state.diagnosticoSelecionado,
    formDirty: state => state.formDirty,
}

const actions = {
    selectCliente({ commit }, cliente) {
        commit('SELECT_CLIENTE', cliente)
    },
    selectDiagnostico({ commit }, diagnostico) {
        if (!diagnostico) {
            commit('SELECT_DIAGNOSTICO', null)
            return
        }
        commit('SELECT_DIAGNOSTICO', {
            id: diagnostico.id,
            clie_id_cliente: diagnostico.clie_id_cliente,
        })
    },
    setFormDirty({ commit }, dirty) {
        commit('SET_FORM_DIRTY', dirty)
    },
    reset({ commit }) {
        commit('RESET')
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
}
